import '../../App.css';
import React from 'react';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Row, Col } from 'reactstrap';
import { ToastContainer } from 'react-toastify';
// import { toastFunction } from '../tasksContent/getTaskFunctions'; 
import i18n from "i18n-react";
import DefaultSpinner from '../../components/DefaultSpinner';
import DefaultModal from '../../components/DefaultModal';
import { DefaultAjax, modalForbidden } from "../../components/DefaultAjax";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import * as FaIcons from "react-icons/fa";
import { toastFunction } from '../../components/mainFunctions';

const url = process.env.REACT_APP_API_URL;

class AuditSentEmails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            auditSentEmailsList: [],
            startDate: moment().add(-12, 'hour'),
            endDate: moment().add(12, 'hour'),
            servicesList: [],
            usersList: [],
            selectedServicesValue: "",
            modalContent: "",
            spinner: "",
            selectedUserValue: ""
        };
    }

    componentDidMount() {
        this.getServicesAjax();
        this.getAuditSentEmails();
    }

    getDateForSearch = (date) => {
        let startDate = new Date(date);
        let m = startDate.getMonth() + 1;
        let mes = (m < 10) ? '0' + m : m;
        let day = startDate.getDate();
        let dayForShow = (day < 10) ? '0' + day : day;
        startDate = dayForShow + "-" + mes + "-" + startDate.getFullYear();

        return startDate
    }

    getSplitedTenantId = (forSplit) => {
        let valueSplit = forSplit.split("-");
        return valueSplit[1]
    }

    getAuditSentEmails = () => {
        let instanceType = document.querySelector("#instanceType").value;
        let independent = document.querySelector("#independent").value;
        this.setState({
            spinner: <DefaultSpinner instanceType={instanceType}
                independent={independent} />
        })

        let params = {

        };

        params.startDate = this.getDateForSearch(this.state.startDate) || '';
        params.endDate = this.getDateForSearch(this.state.endDate) || '';
        params.serviceId = this.getSplitedTenantId(this.state.selectedServicesValue) || 0;
        params.username = this.state.selectedUserValue || '';

        console.log(params)

        DefaultAjax('').get(`mailTrackingAudit/mailTrackingAudit?startDate=${params.startDate}&endDate=${params.endDate}&serviceId=${params.serviceId}&username=${params.username}`)
            .then((res) => {
                if (res) {
                    let result = JSON.parse(res.data);
                    this.setState({
                        spinner: "",
                        auditSentEmailsList: result
                    })
                }
            }).catch((error) => {
                this.setState({
                    modalContent: "",
                    spinner: "",
                    component: error.message
                });
                if (error.response) {
                    if (error.response.status === 403) {
                        setTimeout(() => {
                            this.setState({ modalContent: modalForbidden() });
                        }, 10);
                    }
                }
            });
    }

    getServicesAjax = () => {

        DefaultAjax('').get("mailTrackingAudit/services")
            .then((res) => {
                if (res) {

                    let result = JSON.parse(res.data);

                    this.setState({
                        spinner: "",
                        servicesList: result
                    });

                }
            }).catch((error) => {
                this.setState({
                    modalContent: "",
                    spinner: "",
                    component: error.message
                });
                if (error.response) {
                    if (error.response.status === 403) {
                        setTimeout(() => {
                            this.setState({ modalContent: modalForbidden() });
                        }, 10);
                    }
                }
            });

    }

    filterUsers = e => {
        let filterSearch = e.target.value.toLowerCase();
        this.searchForShowOrHideUserService('user', filterSearch);
    }

    filterServices = e => {
        let filterSearch = e.target.value.toLowerCase();
        this.searchForShowOrHideUserService('service', filterSearch);
    }

    searchForShowOrHideUserService = (isUserOrService, value) => {
        let listForSearch = [];
        let name, id;
        if (isUserOrService === 'user') {
            listForSearch = this.state.usersList;
        } else {
            listForSearch = this.state.servicesList;
        }


        listForSearch.map((u) => {
            name = u.name.toLowerCase();
            id = u.id.toString();
            if (name.indexOf(value) !== -1 || id.indexOf(value) !== -1) {
                document.getElementById("divUserServiceRadio-" + u.id).style.display = 'block';
            } else {
                document.getElementById("divUserServiceRadio-" + u.id).style.display = 'none';
            }
            return u;
        })

        if (value === '') {

            this.state.usersList.map((u) => {
                document.getElementById("divUserServiceRadio-" + u.id).style.display = 'block';
                return u;
            })

        }
    }

    getUsersAjax = () => {
        let tenantId = this.getSplitedTenantId(this.state.selectedServicesValue);
        DefaultAjax('').get("mailTrackingAudit/users?tenantId=" + tenantId)
            .then((res) => {

                if (res) {

                    let result = JSON.parse(res.data);

                    this.setState({
                        spinner: "",
                        usersList: result
                    });

                    setTimeout(() => {
                        this.showServiceUserModal('user');
                    }, 300);

                }

            }).catch((error) => {
                this.setState({
                    modalContent: "",
                    spinner: "",
                    component: error.message
                });
                if (error.response) {
                    if (error.response.status === 403) {
                        setTimeout(() => {
                            this.setState({ modalContent: modalForbidden() });
                        }, 10);
                    }
                }
            });
    }

    handleServiceOptionChange = (changeEvent) => {

        let inputs = document.querySelectorAll("input[type=radio]");
        for (let row of inputs) {
            if (changeEvent.target.value === row.value) {
                row.checked = true;
                this.setState({
                    selectedServicesValue: changeEvent.target.nextSibling.wholeText
                });
            } else {
                row.checked = false
            }
        }
    }

    handleUserOptionChange = (changeEvent) => {

        let inputs = document.querySelectorAll("input[type=radio]");

        for (let row of inputs) {

            if (changeEvent.target.value === row.value) {

                const nextSibling = changeEvent.target.nextSibling;
                console.log("nextSibling = " + nextSibling);

                const fullText = nextSibling && nextSibling.nodeType === Node.TEXT_NODE ? nextSibling.wholeText.trim() : "";
                console.log("fullText = " + fullText);

                const selectedValue = fullText.split("-")[0];
                console.log("selectedValue = " + selectedValue);

                this.setState({
                    selectedUserValue: selectedValue
                });

            } else {
                row.checked = false
            }

        }

    }

    handleCallback = (start, end) => {
        this.setState({ startDate: start });
        this.setState({ endDate: end });
    }

    selectServicesForFilter = () => {
        if (this.state.selectedServicesValue !== "" && document.querySelectorAll(".usersListRadio").length === 0) {
            this.getUsersAjax();
        } else {
            this.setState({ modalContent: "" })
        }
    }

    getServiceHtml = () => {

        const { servicesList } = this.state;

        return servicesList.map((r) => (
            <div className="radio" key={r.id} id={"divUserServiceRadio-" + r.id}>
                <label>
                    <input type="radio" value={r.id} onChange={this.handleServiceOptionChange} />
                    {r.name}-{r.serviceId}
                </label>
            </div>
        ));
    };

    getUsersHtml = () => {
        return <div>
            <div>
                <input type='text' className="form-control inputStandard" onChange={this.filterUsers} />
            </div>
            <br />
            {this.state.usersList.map((u) => {
                return (
                    <div className="radio usersListRadio" key={u.id} id={"divUserServiceRadio-" + u.id} >
                        <label>
                            <input type="radio" value={u.id}
                                onChange={this.handleUserOptionChange} />
                            {u.username}-{u.fullname}
                        </label>
                    </div>
                )
            })}
        </div>
    }

    showServiceUserModal = (userService) => {
        this.setState({
            modalContent: ""
        });
        let content, title = "";
        if (userService === 'service') {
            this.setState({
                selectedServicesValue: "",
                selectedUserValue: ""
            })

            content = this.getServiceHtml();

            title = i18n.translate("default_services");
        } else {
            if (this.state.selectedServicesValue === "") {
                content = this.getServiceHtml();
                title = i18n.translate("default_services");
                toastFunction(i18n.translate("please_select_a_service"), "warning");
            } else {
                this.setState({ selectedUserValue: "" })
                content = this.getUsersHtml();
                title = i18n.translate("default_users");
            }
        }

        setTimeout(() => {
            let buttons = [{ text: i18n.translate("default_accept"), function: this.selectServicesForFilter },
            { text: i18n.translate("default_close"), function: "" }]
            this.setState({
                modalContent: <DefaultModal show={true} title={title}
                    content={content} modalClass={''}
                    buttons={buttons} size={''} />
            })
        }, 20);
    }

    render() {
        return (
            <>
                {this.state.modalContent}
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover></ToastContainer>
                <nav className='navbar'>
                    <Row style={{ width: '60%' }}>
                        <Col sm={12} md={4} lg={4} xl={4}>
                            <label>{i18n.translate("date")}</label>
                            <div>
                                <DateRangePicker
                                    initialSettings={{ startDate: this.state.startDate, endDate: this.state.endDate }}
                                    onCallback={this.handleCallback}>
                                    <input type="text" readOnly style={{ fontSize: "12px", padding: "5px", cursor: "pointer", display: "inline-block", width: '100%' }} className="form-control inputStandard" />
                                </DateRangePicker>
                            </div>

                        </Col>
                        {' '}
                        <Col sm={12} md={4} lg={4} xl={4}>
                            <label>{i18n.translate("default_service")}</label>
                            <div>
                                <input type="text" onClick={() => this.showServiceUserModal('service')}
                                    readOnly style={{ fontSize: "12px", padding: "5px", cursor: "pointer" }}
                                    className="form-control inputStandard" value={this.state.selectedServicesValue} />
                            </div>
                        </Col>
                        {' '}
                        <Col sm={12} md={4} lg={4} xl={4}>
                            <label>{i18n.translate("default_user")}</label>
                            <div>
                                <input type="text" onClick={() => this.showServiceUserModal('user')}
                                    readOnly style={{ fontSize: "12px", padding: "5px", cursor: "pointer" }}
                                    className="form-control inputStandard" value={this.state.selectedUserValue} />
                            </div>
                        </Col>
                        {' '}
                    </Row>
                    <div style={{ paddingTop: "22px", width: '40%' }}>
                        <div style={{ display: 'inline-block' }}>
                            <button className='buttonMzateSecondary' onClick={() => this.getAuditSentEmails()}>
                                <FaIcons.FaSearch />
                                <span>{i18n.translate("default_search")}</span>
                            </button>
                        </div>
                        {' '}
                    </div>
                </nav>
                <br />
                <div id='bodyContent' className='bodyContent'>
                    {this.state.spinner}
                    <Table className='table table-hover divIndexTable'>
                        <tbody>
                            <tr>
                                <th className='firstcell'>{i18n.translate("creation_date")}</th>
                                <th className='cellgroup'>{i18n.translate("default_affair")}</th>
                                <th className='cellgroup'>{i18n.translate("default_type")}</th>
                                <th className='cellgroup'>{i18n.translate("default_service")}</th>
                                <th className='cellgroup'>{i18n.translate("username")}</th>
                                <th className='cellgroup'>{i18n.translate("fullname")}</th>
                                <th className='cellgroup'>{i18n.translate("default_email")}</th>
                            </tr>
                            {this.state.auditSentEmailsList.map((list) => {
                                return (
                                    <tr key={list.id}>
                                        <td>
                                            {list.date}
                                        </td>
                                        <td>
                                            {list.subject}
                                        </td>
                                        <td>
                                            {list.type}
                                        </td>
                                        <td>
                                            {list.service}
                                        </td>
                                        <td>
                                            {list.username}
                                        </td>
                                        <td>
                                            {list.fullname}
                                        </td>
                                        <td>
                                            {list.email}
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </div>
            </>
        );
    }

}
export default AuditSentEmails;